import { gql } from '@apollo/client';

export const HOST_GROUPS = gql`
  query BookingsHostGroups {
    hostGroupsOverview {
      id
      title
    }
    hostsOverview {
      id
      alias
      position
      group_id
      client_sessions {
        finished_at
        started_at
        time_left
        id
      }
      user {
        nickname
        phone
        uuid
      }
    }
  }
`;

export const BOOKINGS = gql`
  query bookingsV2($from: DateTime, $to: DateTime) {
    getBookings(from: $from, to: $to) {
      data {
        id
        group
        hostIds
        byClient
        client {
          uuid
          nickname
          phone
        }
        from
        to
        status
        comment
      }
    }
  }
`;
